varying vec2 vUv; 
varying vec3 vNormal; 
varying vec3 vPos; 
varying vec3 vWorldPos; 
// 
uniform vec3 u_targetPos;
void main(){



    vec4 modelPosition = modelMatrix * instanceMatrix* vec4(position, 1.0);




    vec4 viewPosition =  viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;


    float dist = distance(modelPosition.x, u_targetPos.x);

    // aditionnal calculations
    vUv = uv;
    vNormal = normal;
    vPos = position;
    vWorldPos = modelPosition.xyz;

}